import ActiveController from "rapid/controller";
import {clone, filter, forEach, includes, uniqBy} from "lodash";
const dependencies = ["$Company", "$Deployment", "$Configuration", "$companies"];

export class apiSelectSearchController extends ActiveController {
    constructor($injector, $rootScope, $element, $timeout) {
        "ngInject";
        super($injector, dependencies);

        this.$rootScope = $rootScope;
        this.$element = angular.element($element);
        this.componentId = angular.copy(Math.random().toString(36).substr(2, 10));
        this.elementsArray = [];
        this.searchTerm = "";
        this.$timeout = $timeout;
    }

    $onInit() {
        this.$element.find("input").on("keydown", function(ev) {
            ev.stopPropagation();
        });
        if (this.selectedValues) {
            this.elementsArray.push(...this.selectedValues);
        }
        this.prewModel = this.model;
    }
    

    searchFilter() {
        const newValue = clone(this.searchTerm);
        this.searhDelayTimeout = setTimeout(() => {
            const prewValue = clone(this.searchTerm);
            if (prewValue === newValue) {
                clearTimeout(this.searhDelayTimeout);
                this.onFocus(this.searchTerm);
            }
        }, 2000);
    }

    clearSearchTerm() {
        this.searchTerm = "";
    }

    change(model) {
        if (this.collection === "configuration") {
            if (this.shouldUpdateConfigList(model, this.prewModel)) {
                this.onValueChange({value: model});
            }
            this.prewModel = model;
        } else {
            if(this.prewModel !== model) {
                this.onValueChange({value: model});
                this.prewModel = model;
            }
        }
    }

    shouldUpdateConfigList(newValue, previousValue) {
        let shouldUpdate = false;

        if (newValue.length !== previousValue.length) {
            shouldUpdate = true;
        } else {
            newValue.forEach((m, i)=> {
                if (previousValue[i] !== m) {
                    shouldUpdate = true;
                }
            });
        }

        return shouldUpdate;
    }


    onFocus(search) {
        let elements = null;
        switch (this.collection) {
            case "company":
                elements = this.$Company.query({ordering: "name", search: search});
                break;

            case "configuration":
                elements = this.$Configuration.query({ordering: "name", search: search});
                break;

            case "deployment":
                elements = this.$Deployment.query({ordering: "name", search: search});
                break;

        }
        elements.$promise.then((resp) => {
            this.elementsArray = [];
            if (this.selectedValues && !this.searchTerm.length) {
                this.elementsArray.push(...this.selectedValues);
            }
            this.elementsArray.push(...resp);
            this.elementsArray = uniqBy(this.elementsArray, "url");
        });
    }

    transformConfigurationArray(array) {
        if (!this.elementsArray.length) {
            return;
        }
        let newArray = [];
        newArray = filter(this.elementsArray, (c) => {
            if (c) {
                return  includes(array, c.url);
            }
        });
        let namesArray = [];
        forEach(newArray, (c) => {
            namesArray.push(c.name);
        });
        namesArray = namesArray.toString().replace(/,/g, "\n");
        return namesArray;
    }

}


// WEBPACK FOOTER //
// ./sources/components/common/api-select-search/api-select-search.controller.js